import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import styled from 'styled-components';

import Image from '../../core/Image';
import Modal from './Modal';
import ContactHelper from '../../core/libs/ContactHelper';
import PersonalInfo from '../contactInfo/PersonalInfo';
import ProfessionalInfo from '../contactInfo/ProfessionalInfo';
import OtherInfo from '../contactInfo/OtherInfo';
import DeletePopup from './DeletePopup';
import { useContactsContext } from '../../contexts/ContactsContext';
import { Separator } from '../styled';
import {
  ViewContactHeader,
  ViewContactHeaderMain,
  ViewContactIconClose,
  ViewContactIconEdit,
  ViewContactIconTrash,
  ViewContactName,
  ViewContactNameContainer,
  ViewContactSubtitle,
} from '../styled/ViewContact';

import close from '../../core/assets/close.png';
import pencil from '../../core/assets/pencil.png';
import trash from '../../core/assets/trash.png';
// import star_outline from '../../core/assets/star_outline.png';
// import star_full from '../../core/assets/top_star.png';
// import email_icon from '../../core/assets/email.png';
// import phone_icon from '../../core/assets/phone.png';
// import office_icon from '../../core/assets/office.png';
// import calendar_icon from '../../core/assets/calendar.png';
// import briefcase_icon from '../../core/assets/briefcase.png';

// import facebook_icon from '../../core/assets/thirdPartyImages/ic_facebook.png';
// import linkedin_icon from '../../core/assets/thirdPartyImages/ic_linkedin.png';
// import twitter_icon from '../../core/assets/thirdPartyImages/ic_twitter.png';
// import instagram_icon from '../../core/assets/thirdPartyImages/ic_instagram_big.png';
// import venmo_icon from '../../core/assets/thirdPartyImages/ic_venmo.png';
// import url_icon from '../../core/assets/thirdPartyImages/ic_url_big.png';
// import messenger_icon from '../../core/assets/thirdPartyImages/ic_messenger_big.png';
// import whatsapp_icon from '../../core/assets/thirdPartyImages/ic_whatsapp_big.png';
// import yelp_icon from '../../core/assets/thirdPartyImages/ic_yelp.png';
// import snapchat_icon from '../../core/assets/thirdPartyImages/ic_snapchat.png';

interface Props {
  open: boolean;
}

export default function ViewContactModal(props: Props) {
  const contactsContext = useContactsContext();
  const [showDelete, setShowDelete] = useState(false);
  const [showMenu, setShowMenu] = useState(true);

  const contact = contactsContext.selectedContact;

  const onDeleteClose = () => {
    setShowDelete(false);
    setShowMenu(true);
  };

  const onClose = () => {
    setShowDelete(false);
    setShowMenu(true);
    contactsContext.setSelectedContact(undefined);
  };

  const onDelete = () => {
    setShowMenu(false);
    setShowDelete(true);
  };

  const doDelete = () => {
    setShowDelete(false);
    setShowMenu(true);
    contactsContext.setSelectedContact(undefined);
    if (contact && contactsContext.onDelete) {
      contactsContext.onDelete(contact);
    }
  };

  const cancelDelete = () => {
    setShowDelete(false);
    setShowMenu(true);
  };

  const onEdit = () => {
    setShowMenu(true);
    setShowDelete(false);
    contactsContext.setSelectedContact(undefined);
    if (contact) {
      contactsContext.setContactToEdit(contact);
    }
  };

  // const onStar = (event: any) => {
  //   if (selectedContact && props.onStar) {
  //     props.onStar(selectedContact);
  //   }
  // };

  const hasPersonalInfo = () => {
    return contact?.personalEmail?.displayEmail || contact?.personalMobile?.displayNumber ||
      contact?.personalLandline?.displayNumber || contact?.birthday || contact?.personalAddress?.address1;
  };

  const hasProfessionalInfo = () => {
    return contact?.primaryProfessionalInfo?.jobTitle || contact?.primaryProfessionalInfo?.companyName ||
      contact?.professionalEmail?.displayEmail || contact?.professionalMobile?.displayNumber ||
      contact?.professionalLandline?.displayNumber || contact?.professionalAddress?.address1 ||
      (contact?.professionalThirdPartyIds?.length || 0) > 0;
  };

  const hasOtherInfo = () => {
    return (contact?.otherEmails?.length || 0) > 0 || (contact?.otherPhones?.length || 0) > 0 ||
      (contact?.otherAddresses?.length || 0) > 0 || (contact?.otherThirdPartyIds?.length || 0) > 0;
  };

  if (!props.open || !contact) {
    return <></>;
  }

  const showDeleteIcon = contactsContext.selfContact?.contactId !== contact.contactId;

  return (
    <Modal open={props.open} onClose={onClose} modalEdit={false}>
      <ViewContactContainer>
        <Row data-contact-id={contact.contactId}>
          <ViewContactHeader>
            <ViewContactHeaderMain>
              {contact.photoUrl &&
                <Image src={contact.photoUrl ?? ''} showSpinner={true}/>}
              <ViewContactNameContainer>
                <ViewContactName>{ContactHelper.getName(contact)}</ViewContactName>
                {(contact.primaryMobile && contact.primaryMobile.displayNumber) &&
                  <div>{contact.primaryMobile.displayNumber}</div>
                }
              </ViewContactNameContainer>
            </ViewContactHeaderMain>
            <div>
              {
                showMenu ? (
                  <div>
                    {onEdit && <ViewContactIconEdit alt="Edit" src={pencil} onClick={onEdit}/>}
                    {showDeleteIcon && <ViewContactIconTrash alt="Delete" src={trash} onClick={onDelete}/> }
                    <ViewContactIconClose alt="Close" src={close} onClick={onClose}/>
                  </div>
                ) : null
              }
              {
                showDelete ? (
                  <DeletePopup onClose={onDeleteClose} doDelete={doDelete} cancelDelete={cancelDelete}/>
                ) : null
              }
            </div>
          </ViewContactHeader>
          <div>
            {hasPersonalInfo() && <>
              <ViewContactSubtitle>Personal</ViewContactSubtitle>
              <Separator/>
              <PersonalInfo contact={contact}/>
            </>}
          </div>
          <div>
            {hasProfessionalInfo() && <>
              <ViewContactSubtitle>Professional</ViewContactSubtitle>
              <Separator/>
              <ProfessionalInfo contact={contact}/>
            </>}
          </div>
          <div>
            {hasOtherInfo() && <>
              <ViewContactSubtitle>Other</ViewContactSubtitle>
              <Separator/>
              <OtherInfo contact={contact}/>
            </>}
          </div>
        </Row>
      </ViewContactContainer>
    </Modal>
  );
}

const ViewContactContainer = styled.div`
  ${Separator} {
    margin: 0 30px 6px 0;
    width: 100%;
  }
`;
